<template>
  <div class="heat-all">
    <div class="partner-what">
      <div class="title">
        <img src="@/assets/images/partner/white.png" width="266" />
      </div>
      <div
        class="info"
      >美菜“城市代理商”是指使用美菜品牌和高效IT系统，在代理城市开设美菜站点，面向区域内餐饮商户和社区用户提供食材配送服务。城市代理商在美菜辅导、扶持下经营。</div>
      <div class="sign">
        <div class="signUp" @click="handleClick">我要报名</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "heat",
  data() {
    return {};
  },
  methods: {
    handleClick() {
      this.$emit("change", true);
    },
  },
};
</script>

<style lang="scss" scoped>
.heat-all {
  background: url(~@/assets/images/partner/partner-bg.jpg) no-repeat center top;
  height: 400px;
}
.partner-what {
  width: 1000px;
  margin: 0 auto;
  height: 400px;
  position: relative;
  .title {
    position: absolute;
    top: 85px;
    left: 407px;
  }
  .info {
    position: absolute;
    top: 175px;
    left: 408px;
    width: 440px;
    color: #fff;
    font-size: 19px;
    line-height: 1.8;
  }
  .sign {
    position: absolute;
    bottom: 25px;
    right: 30px;
    .signUp {
      width: 160px;
      height: 50px;
      display: block;
      background: #fab139;
      color: #fff;
      border-radius: 80px;
      text-align: center;
      line-height: 50px;
      font-size: 24px;
      &:hover {
        background: #eda021;
        text-decoration: none;
      }
    }
  }
}
</style>
